import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '光盘有奖 互动打卡';
const baseUrl = 'guangpan20221223';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
    showfooter: true,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'intr',
      name: `${baseUrl}-intr`,
      component: () => import('./pages/Intr.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'citysort',
      name: `${baseUrl}-citysort`,
      component: () => import('./pages/Citysort.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'activity',
      name: `${baseUrl}-activity`,
      component: () => import('./pages/Activity.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'mytrun',
      name: `${baseUrl}-mytrun`,
      component: () => import('./pages/Mytrun.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'turndetail',
      name: `${baseUrl}-turndetail`,
      component: () => import('./pages/TurnDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'luckdraw',
      name: `${baseUrl}-luckdraw`,
      component: () => import('./pages/LuckDraw.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'allmytrun',
      name: `${baseUrl}-allmytrun`,
      component: () => import('./pages/AllMytrun.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'citytrun',
      name: `${baseUrl}-citytrun`,
      component: () => import('./pages/Citytrun.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'citytrunnow',
      name: `${baseUrl}-citytrunnow`,
      component: () => import('./pages/Citytrunnow.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
  ],
};

export default route;
